import { useMutation, useQuery } from '@tanstack/react-query';
import { gameLaunch, gameLaunchNew, fetchGameList, fetchGameListNew, authWBGames } from '../api/gameApi';

export const useGameLaunchMutation = () => {
  return useMutation({
    mutationFn: gameLaunch,
  });
};

export const useGameLaunchNewMutation = () => {
  return useMutation({
    mutationFn: gameLaunchNew,
  });
};

export const useGameListQuery = (provider) => {
  return useQuery({
    queryKey: ['gameList', provider],
    queryFn: () => fetchGameList(provider),
    enabled: !!provider,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });
};

export const useGameListNewQuery = (provider) => {
  return useQuery({
    queryKey: ['gameListNew', provider],
    queryFn: () => fetchGameListNew(provider),
    enabled: !!provider,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
};

export const useAuthWBGamesMutation = () => {
  return useMutation({
    mutationFn: authWBGames,
  });
};
